import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
  setChecklistSportDefault, 
  setChecklistYearDefault, 
  setChecklistManufacturerDefault 
} from '../store/system/system.action';
import { 
  selectChecklistSportDefault, 
  selectChecklistYearDefault, 
  selectChecklistManufacturerDefault 
} from '../store/system/system.selector';

export const useSystemInitialization = () => {
  const dispatch = useDispatch();
  const checklistSportDefault = useSelector(selectChecklistSportDefault);
  const checklistYearDefault = useSelector(selectChecklistYearDefault);
  const checklistManufacturerDefault = useSelector(selectChecklistManufacturerDefault);

  useEffect(() => {
    // Initialize default values if they're not set
    if (!checklistSportDefault) {
      dispatch(setChecklistSportDefault("MLB"));
    }
    if (!checklistYearDefault) {
      dispatch(setChecklistYearDefault("2026"));
    }
    if (!checklistManufacturerDefault) {
      dispatch(setChecklistManufacturerDefault("Topps"));
    }
  }, [dispatch, checklistSportDefault, checklistYearDefault, checklistManufacturerDefault]);

  return {
    checklistSportDefault: checklistSportDefault || "MLB",
    checklistYearDefault: checklistYearDefault || "2026",
    checklistManufacturerDefault: checklistManufacturerDefault || "Topps"
  };
};
